import { marketplaceCampaignSchema } from "@redotech/redo-model/marketplace/campaigns";
import * as z from "zod/v4";

export const getCampaignById = {
  name: "getCampaignById" as const,
  input: z.object({ id: z.string().min(1, "Campaign ID is required") }),
  output: z.object({ campaign: marketplaceCampaignSchema.nullable() }),
};
